import React from 'react'

interface Props {
  ms: number
  unit?: string
  digits?: number
}

interface State { }

export class TimeValue extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  formatTime(ms: number) {
    const unit = this.props.unit || 's'
    const digits = this.props.digits || 2
    const value = unit === 's' ? ms / 1000 : ms
    return value.toFixed(digits)
  }

  formatUnit() {
    const unit = this.props.unit || 's'
    return unit === 's' ? '秒' : 'ms'
  }

  public render() {
    return (
      <>
        <span className="time-value">{this.formatTime(this.props.ms)}</span>
        <small className="time-unit"> {this.formatUnit()}</small>
      </>
    )
  }
}